import React from 'react'
import { Svg } from './Svg'

export function Warning(props): React.JSX.Element {
    return (
        <Svg fill="currentColor" {...props} viewBox="0 0 256 256">
            <line fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" x1="128" x2="128" y1="104" y2="144" />
            <path d="M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16" />
            <circle cx="128" cy="180" r="12"/>
        </Svg>
    )
}
